
<template>
    <v-main>
        <v-container fluid>  
            <v-card flat>
                <v-row cols="12">
                    <v-col cols="12" ><v-card-title class="justify-center">{{this.title}}</v-card-title></v-col>
                </v-row>
                <v-divider class="mb-2"/>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Type</th>
                            <th>Type description</th>
                            <th>Language</th>
                            <th>Value</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, i) in pripTaal" :key="i">
                        <tr :class="{'color': i%2!==0}">
                            <td>{{ item.prip_nr }}</td>
                            <td>{{ item.priptaal_veld }}</td>
                            <td>{{ item.priptaal_veld_oms }}</td>
                            <td>{{ item.priptaal_taal_code }}</td>
                            <td>{{ item.priptaal_waarde }}</td>
                            <td>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="editPripTaal(item.priptaal_encrid, item.priptaal_veld_oms)">
                                                <v-icon>mdi-file-document-edit-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit text</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>  
                </v-simple-table>  
            </v-card>  
        </v-container>
        <navBar title="Ares - Various" :home="true" type="various"/>   
        <editPripTaal ref="editPripTaal" @reload="searchPripTaal"/>
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue"
    import editPripTaal from "@/views/syst/prip/editPripTaal.vue";
    export default {
        components: {
            navBar,
            editPripTaal
        },
        props: {
            prip_nr: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                title: "Price improvements texts overview",
                pripTaal: [],
            }  
        },
        mounted() { 
            this.searchPripTaal();
        },
        methods: {
            searchPripTaal() {
                this.$axios.post("ares/json/ares/syst/prip/searchPripTaal.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchPripTaal"
                    },
                    searchPripTaal: {
                        prip_nr: this.prip_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.pripTaal = res.data.searchPripTaal;
                    }
                });
            },
            editPripTaal(priptaal_encrid, priptaal_veld_oms) {
                console.log(priptaal_encrid)
                this.$refs.editPripTaal.openEditPripTaal(priptaal_encrid, priptaal_veld_oms)
            },
        }
    };
</script> 


<style scoped>
  .color {
    background-color: #faf8f8;
  }
</style>